import { render } from "./IconHosting.vue?vue&type=template&id=4d9d3c5b"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconHosting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d9d3c5b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d9d3c5b', __exports__)) {
    api.reload('4d9d3c5b', __exports__)
  }
  
  module.hot.accept("./IconHosting.vue?vue&type=template&id=4d9d3c5b", () => {
    api.rerender('4d9d3c5b', render)
  })

}


export default __exports__